export const OPEN_REGISTRATION_MODAL = "OPEN_REGISTRATION_MODAL";
export const CLOSE_REGISTRATION_MODAL = "CLOSE_REGISTRATION_MODAL";
